<template>
  <div class="warp">
    <div class="item-1">
      <ul>
        <li>业主公司：{{contract.lesseeTransactorNickname}}</li>
        <li>物业公司：{{contract.propertyCompanyName}}</li>
        <li>办理人：{{contract.lesseeTransactorNickname}}</li>
        <li>办理人：{{contract.propertyTransactorNickname}}</li>
        <!-- <li>合同利润抽成：{{contract.takePercentageFromProfit}}</li> -->
        <li>合同状态：{{status[contract.status]}}</li>
        <li>合同状态变更时间：{{contract.statusModifyingTime}}</li>
      </ul>
    </div>
    <div class="title">场地列表</div>
    <div class="item-2">
      <ul>
        <li v-for="(obj,index) in contract.areas" :key="index">{{obj.name}}</li>
      </ul>
    </div>
    <div class="title">能源计价表</div>
    <div class="item-3">
      <template v-for="(item,index) in energyPricingConfig">
        <div class="model-1 model" v-if="getModelForKey(item,'view') === 2" :key="index">
          <ul>
            <li>能源类型：{{ energyType[item.energyType]}}</li>
            <li>计价模型：{{ getModelForKey(item,'name')}}</li>
            <li>价格：￥{{ item.params.unitPrice }}</li>
          </ul>
        </div>
        <div class="model-2 model" v-else-if="getModelForKey(item,'view') === 3" :key="index">
          <div>
            <ul>
              <li>能源类型：{{ energyType[item.energyType]}}</li>
              <li>计价模型：{{ getModelForKey(item,'name')}}</li>
              <li></li>
            </ul>
          </div>
          <div class="flex">
            <div>阶梯价格：</div>
            <div>
              <table border="0" cellspacing="1" cellpadding="0">
                <tr>
                  <td>阈值</td>
                  <td>单价</td>
                </tr>
                <tr v-for="(obj,key) in item.params" :key="key">
                  <td>{{obj.thresholdValue}}</td>
                  <td>￥{{obj.unitPrice}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="model-3 model" v-else-if="getModelForKey(item,'view') === 1" :key="index">
          <div>
            <ul>
              <li>能源类型：{{ energyType[item.energyType]}}</li>
              <li>计价模型：{{ getModelForKey(item,'name')}}</li>
              <li></li>
            </ul>
          </div>
          <div class="flex">
            <div>时段区间：</div>
            <div class="flex-1">
              <table border="0" cellspacing="1" cellpadding="0">
                <tr>
                  <td class="td-title">名称：</td>
                  <td>峰期</td>
                  <td class="td-title">单价：</td>
                  <td>￥{{item.params.unitPrice.peak}}</td>
                </tr>
                <tr>
                  <td class="td-title">时间段：</td>
                  <td colspan="3">
                    <template v-for="(obj,key) in item.params.timeSegment.peak">
                      <div :key="key">
                        <label>{{obj.startTime}}</label>-<label>{{obj.endTime }}</label>
                      </div>
                    </template>
                  </td>
                </tr>
              </table>
              <table border="0" cellspacing="1" cellpadding="0">
                <tr>
                  <td class="td-title">名称：</td>
                  <td>平期</td>
                  <td class="td-title">单价：</td>
                  <td>￥{{item.params.unitPrice.plain}}</td>
                </tr>
                <tr>
                  <td class="td-title">时间段：</td>
                  <td colspan="3">
                    <template v-for="(obj,key) in item.params.timeSegment.plain">
                      <div :key="key">
                        <label>{{obj.startTime}}</label>-<label>{{obj.endTime }}</label>
                      </div>
                    </template>
                  </td>
                </tr>
              </table>
              <table border="0" cellspacing="1" cellpadding="0">
                <tr>
                  <td class="td-title">名称：</td>
                  <td>谷期</td>
                  <td class="td-title">单价：</td>
                  <td>￥{{item.params.unitPrice.valley}}</td>
                </tr>
                <tr>
                  <td class="td-title">时间段：</td>
                  <td colspan="3">
                    <template v-for="(obj,key) in item.params.timeSegment.valley">
                      <div :key="key">
                        <label>{{obj.startTime}}</label>-<label>{{obj.endTime }}</label>
                      </div>
                    </template>
                  </td>
                </tr>
              </table>
              <table border="0" cellspacing="1" cellpadding="0">
                <tr>
                  <td class="td-title">名称：</td>
                  <td>尖期</td>
                  <td class="td-title">单价：</td>
                  <td>￥{{item.params.unitPrice.sharp}}</td>
                </tr>
                <tr>
                  <td class="td-title">时间段：</td>
                  <td colspan="3">
                    <template v-for="(obj,key) in item.params.timeSegment.sharp">
                      <div :key="key">
                        <label>{{obj.startTime}}</label>-<label>{{obj.endTime }}</label>
                      </div>
                    </template>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="title">基本费用表</div>
    <div class="item-4">
      <table border="0" cellspacing="1" cellpadding="0">
        <tr>
          <td>费用名称</td>
          <td class="w-100">费用</td>
        </tr>
        <tr v-for="(item,index) in contract.basicCharges" :key="index">
          <td>{{item.name}}</td>
          <td class="w-100">￥{{item.value}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import config from '@common/config/index.js'
export default {
  props: ["contract"],
  data () {
    return {
      energyType: config.energyType,
      model: config.model,
      status: config.contractState,
      energyPricingConfig: null
    }
  },
  created () {
    let data = []
    for (let i = 0; i < this.contract.energyPricingConfig.length; i++) {
      let item = JSON.parse(JSON.stringify(this.contract.energyPricingConfig[i]));
      item.params = JSON.parse(item.params)
      data.push(item)
    }
    this.energyPricingConfig = data
  },
  methods: {
    getModelForKey (item, key) {
      let model = null
      if (this.model[item.energyType]) {
        if (this.model[item.energyType].model[item.model]) {
          model = this.model[item.energyType].model[item.model]
        }
      }

      if (model) {
        return model[key]
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;

  ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
  }
  .title {
    height: 32px;
    line-height: 32px;
    font-weight: bold;
    font-size: 16px;
    margin-top: 20px;
  }
  .item-1 {
    padding-left: 20px;
    ul {
      li {
        float: left;
        width: 50%;
      }
    }
  }
  .item-2 {
    padding-left: 20px;
    ul {
      list-style: auto;
      li {
        float: left;
        padding-right: 30px;
      }
    }
  }
  .item-3 {
    padding-left: 20px;
    display: flex;
    flex-flow: column;
    .model-1 {
      li {
        float: left;
        width: 33%;
      }
    }
    .model-2 {
      display: flex;
      flex-flow: column;
      li {
        float: left;
        width: 33%;
      }
      table {
        background: #ccc;
        td {
          background: #fff;
          width: 60px;
          padding: 4px 6px;
        }
      }
    }
    .model-3 {
      display: flex;
      flex-flow: column;
      li {
        float: left;
        width: 33%;
      }
      table {
        width: 100%;
        margin-top: 6px;
        background: #ccc;
        td {
          background: #fff;
          padding: 4px 6px;
        }
        .td-title {
          width: 60px;
          text-align: right;
        }
      }
    }
  }
  .item-4 {
    padding-left: 20px;
    table {
      width: 100%;
      background: #ccc;
      td {
        background: #fff;
        padding: 4px 6px;
        text-align: center;
      }
    }
  }
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.w-100 {
  width: 100px;
}
.model {
  padding: 10px 0px;
  border-bottom: 1px dotted #eee;
}
.model:first-child {
  padding-top: 0px;
}
.model:last-child {
  padding-bottom: 0px;
  border-bottom: 0px;
}
</style>